import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/MathClub/components/Archive2022';
import Sidebar2025 from '../MathClub2023/components/Sidebar2025';


const MathCCAClass6to82025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA6to8/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA6to8/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA6to8/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA6to8/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA6to8/5.webp`;



    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                   Bridge builder	                                  
                                </Typography>
                                <br></br>
                               
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Classes: 6 To 8  Date: 13 November 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                   The Mathematics Association organised a “Bridge Builder Activity” for Classes 6 to 8 on 13 November ie Friday. Students constructed model bridges using paper straws and incorporated various geometrical shapes such as triangles, rectangles, and arches. This hands-on activity provided students with practical experience in applying mathematical concepts including Shapes, Angles, Symmetry, Balance, and Structural Strength.
                                    <br></br>
                                    Through the process of planning, designing, and assembling their bridges, students learned how different geometric arrangements contribute to stability and load-bearing capacity. The activity helped them understand the real-life application of mathematics in engineering and design.
                                    <br></br>
                                   The students participated with great enthusiasm and displayed creativity and problem-solving skills in building their bridges. Overall, the activity successfully blended learning with creativity, allowing students to appreciate the significance of mathematics in constructing stable structures.
                                   <br></br>
                                   
                                </Typography>
                            </Box>
                            <Typography
                                      variant={'h6'}
                                      color={'primary'}
                                      align={'center'}
                                      fontWeight={'normal'}
                                    ><br/>
                            "Young minds weave math and symmetry into bridges born from bright vision and built with pride."
                            
                            <br/>
                                    </Typography>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2025 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathCCAClass6to82025;